<template>
  <div class="content-9">
    <div v-if="routeName === 'transfer'" class="content-9__title">
      <span class="content-9__title__text">效果预览</span>
    </div>
    <div v-if="Object.keys(drawInfo).length > 0" :class="{'content-9__content':routeName === 'transfer'}">
      <div
        class="c9-showstyle"
        :class="{ rwd: isRwd }"
        :style="{ 'background-color': data.colorPick, 'width': data.size.split('x')[0] + 'px', 'height': data.size.split('x')[1] + 'px' }"
      >
        <div v-if="isLoading" class="loading" style="flex: 1;">
          <span>Loading...</span>
        </div>
        <template v-else>
          <div class="c9-showstyle__item">
            <div v-if="data.type === 'multiple'" class="selectbox">
              <select v-model="lotteryCode" class="selectbox__select" @change="changeDrawInfoData(lotteryCode)">
                <option v-if="data.selectCode.length === 0" :value="data.defaultCode">{{ data.selectName }}</option>
                <option v-for="item in data.selectCode" v-else :key="item.name" :value="item.code">{{ item.name }}</option>
              </select>
            </div>
            <div v-if="data.type === 'single'">
              {{ data.selectName }}
            </div>
          </div>
          <div class="c9-showstyle__item">
            <div class="c9-showstyle__item__text blue" v-text="periodLabel"></div>
            <div class="c9-showstyle__item__text">期</div>
          </div>
          <div class="c9-showstyle__item full">
            <div v-if="lotteryType === 'pk10'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div
                    class="ball size-middle"
                    :class="{
                      [`ball-0${ball}`]: ball !== 10,
                      'ball-10': ball === 10,
                    }"
                  >
                    <span class="ball__number">{{ ball }}</span>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="(lotteryType === 'ssc' || lotteryType === '11x5' || lotteryType === 'kl8' || lotteryType === 'kl10') && (lotteryCode !== 'cqxync') && (lotteryCode !== 'cqssc')" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div class="ball color--primary size-middle circle">
                    <span class="ball__number">{{ ball }}</span>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="lotteryType === 'k3'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div class="ball size-middle" :class="`dice-${ball}`"></div>
                </div>
              </template>
            </div>
            <div v-if="lotteryType === 'xy28'" class="ballbox no-wrap">
              <div class="ball color--primary size-middle circle">
                <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[0]', 0) }}</span>
              </div>
              <div class="ballbox__item">
                <img src="@/assets/desktop/img/plus.svg" alt="">
              </div>
              <div class="ball color--primary size-middle circle">
                <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[1]', 0) }}</span>
              </div>
              <div class="ballbox__item">
                <img src="@/assets/desktop/img/plus.svg" alt="">
              </div>
              <div class="ball color--primary size-middle circle">
                <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
              </div>
              <div class="ballbox__item">
                <img src="@/assets/desktop/img/equal.svg" alt="">
              </div>
              <div class="ball color--red size-middle circle">
                <span class="ball__number">{{ get(drawInfo, 'prePeriod.balls[0]', 0) + get(drawInfo, 'prePeriod.balls[1]', 0) +get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
              </div>
            </div>
            <div v-if="lotteryType === 'others'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div class="ball color--red size-middle circle">
                    <span class="ball__number">{{ ball }}</span>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="lotteryCode === 'cqxync'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div class="ball size-middle" :class="`haomaimg-${ball}`"></div>
                </div>
              </template>
            </div>
            <div v-if="lotteryCode === 'cqssc'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div :key="`ball-${index}`" class="ballbox__item">
                  <div class="ball size-middle" :class="`zodiac-${ball}`"></div>
                </div>
              </template>
            </div>
            <div v-if="lotteryType === 'hk6'" class="ballbox no-wrap">
              <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
                <div v-if="index === 5" :key="`ball-${index}`" class="ballbox__item">
                  <LotteryBall :number="ball" />
                </div>
                <div v-if="index === 5" :key="`plus-${index}`" class="ballbox__item">
                  <img src="@/assets/desktop/img/plus.svg" alt="">
                </div>
                <div v-else :key="`ball-${index}`" class="ballbox__item">
                  <LotteryBall :number="ball" />
                </div>
              </template>
            </div>
          </div>
          <div class="c9-showstyle__item">
            <div class="c9-showstyle__item__text">下期：</div>
            <div v-if="drawInfo.nextPeriod !== null" class="c9-showstyle__item__text blue" v-text="nextPeriodLabel"></div>
            <div class="c9-showstyle__item__text">期</div>
          </div>
          <div class="c9-showstyle__item">
            <CounterDown
              :draw-info="drawInfo"
              :lottery-code="lotteryCode"
              @changeDrawInfo="changeDrawInfo($event)"
            />
          </div>
        </template>
        <div class="content-9__content__control fn-modified">
          <a class="button-outline btnbox__item" style="margin-right: 8px; padding: 0.5rem;">
            <i class="refresh-img" style="margin-right: 0;" @click="reload(data.defaultCode)"></i>
          </a>
          <a class="button-outline btnbox__item">
            <span class="button-outline__text" @click="goto({ link: `/lottery/trend/${lotteryCode}`, lotteryCode: lotteryCode })">更多</span>
          </a>
        </div>
      </div>
      <div v-if="routeName === 'transfer'" class="c9-ifeame">
        <div class="c9-ifeame__code">
          <span class="c9-ifeame__code__text">{{ iframeData }}</span>
        </div>
        <div class="c9-ifeame__copybtn">
          <a class="button-outline btnbox__item active" @click="doCopy">
            <span class="button-outline__text">复制调用代码</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailDrawInfo_desktop } from '@/api/desktop/basic'
import CounterDown from '@/components/web/common/CounterDown'
import LotteryBall from '@/components/web/common/LotteryBall'
import get from 'lodash.get'
export default {
  name: 'PreviewEffect',
  components: {
    CounterDown,
    LotteryBall
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    isRwd: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      lotteryType: '',
      lotteryCode: '',
      drawInfo: {},
      lotteryDetail: {},
      iframeInfo: {
        width: '980',
        height: '35'
      },
      routeName: this.$route.name,
      isLoading: false
    }
  },
  computed: {
    domain() {
      return window.location.origin
    },
    iframeData() {
      const timeStamp = (new Date()).valueOf()
      const color = this.data.colorPick.substring(1)
      const code = this.data.defaultCode
      const domain = this.domain
      const pathInfo = {
        name: 'transfer-toolbox-code',
        params: { code },
        query: {
          colorPick: color,
          wgt: this.iframeInfo.width,
          hgt: this.iframeInfo.height,
          type: this.data.type
        }
      }
      let path = ''

      if (this.data.type === 'single') {
        path = this.$router.resolve(pathInfo).href
        const iframeSingleString = `${domain}${path}`

        return `
        <iframe
          time-stamp-${timeStamp}
          src="${encodeURI(iframeSingleString)}"
          frameborder="0"
          scrolling="no"
          width="${this.iframeInfo.width}"
          height="${this.iframeInfo.height}"
          onload="${this.iframeOnloadFunctionString(`time-stamp-${timeStamp}`)}"
        ></iframe>
        `
      } else {
        const selectedCodeList = this.data.selectCode.map(item => item.code).join(',')
        pathInfo.query.list = selectedCodeList
        if (this.data.size === '自适应') {
          pathInfo.query.isRwd = 1
        }

        path = this.$router.resolve(pathInfo).href
        const iframeMultipleString = `${domain}${path}`

        return `
        <iframe
          time-stamp-${timeStamp}
          src="${encodeURI(iframeMultipleString)}"
          frameborder="0"
          scrolling="no"
          width="${this.iframeInfo.width}"
          height="${this.iframeInfo.height}"
          onload="${this.iframeOnloadFunctionString(`time-stamp-${timeStamp}`)}"
        ></iframe>`
      }
    },
    periodLabel() {
      return get(this, 'drawInfo.prePeriod.period', '-')
    },
    nextPeriodLabel() {
      return get(this, 'drawInfo.nextPeriod.period', '-')
    }
  },
  watch: {
    'data.defaultCode': {
      handler(code) {
        if (!code) return
        this.lotteryCode = code
        this.changeDrawInfoData(code)
        this.getLotteryDetail(code)
      },
      immediate: true
    },
    'data.size': {
      handler(newVal, oldVal) {
        if (newVal === '自适应') {
          this.iframeInfo.width = '100%'
          this.iframeInfo.height = ''
          return
        }

        const size = newVal.split('x')
        this.iframeInfo.width = size[0]
        this.iframeInfo.height = size[1]
      },
      immediate: true
    }
  },
  methods: {
    async getLotteryType(code) {
      this.lotteryType = await this.$getLotteryType(code)
    },
    async changeDrawInfoData(code) {
      await this.getLotteryType(code)
      const [data, error] = await getDetailDrawInfo_desktop(code)
      if (error) return [null, error]

      this.drawInfo = data[code]
    },
    async getLotteryDetail() {
      const [publicCpMap, error] = await this.$store.dispatch('lottery/getLotteryMap')
      if (error) return

      this.lotteryDetail = publicCpMap[this.data.defaultCode]
    },
    reload(code) {
      this.isLoading = true
      setTimeout(async() => {
        await this.changeDrawInfoData(code)
        await this.getLotteryDetail(code)
        this.isLoading = false
      }, 1000)
    },
    changeDrawInfo(data) {
      this.drawInfo = data
    },
    doCopy() {
      this.$copyText(this.iframeData).then((e) => {
        alert('Copied')
      }, (e) => {
        alert('Can not copy')
      })
    },
    goto(item) {
      this.$router.push(item.link)
    },
    get(obj = {}, query = '', defaultValue = '') {
      return get(obj, query, defaultValue)
    },
    iframeOnloadFunctionString(attribute) {
      return `
      (function(event) {
        var iframe = document.querySelector('iframe[${attribute}]')
        var deviceWidth = screen.width
        var height = 0

        switch (true) {
          case deviceWidth > 592:
            height = 140
            break
          case deviceWidth <= 592 && deviceWidth > 336:
            height = 124
            break
          case deviceWidth <= 336:
            height = 144
            break
        }
        iframe.style.height = height + 'px'
      })()
      `
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 100%;
  text-align: center;
  color: grey;
}
.fn-modified {
  display: flex;
  position: static;
}
</style>

